var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWeb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_275_87)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_275_87)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 0H2.66667C1.19391 0 0 1.19391 0 2.66667V13.3333C0 14.8061 1.19391 16 2.66667 16H13.3333C14.8061 16 16 14.8061 16 13.3333V2.66667C16 1.19391 14.8061 0 13.3333 0Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.29302 7.74377C4.42996 6.03803 5.70295 4.65258 7.35472 4.3448C6.63614 5.3375 6.20904 6.51516 6.12705 7.74377H4.29302ZM11.8059 8.35537C11.669 10.0611 10.396 11.4466 8.74425 11.7544C9.46278 10.7616 9.88992 9.58397 9.97192 8.35537H11.8059ZM6.12705 8.35537C6.20904 9.58397 6.63614 10.7616 7.35472 11.7544C5.70295 11.4466 4.42996 10.0611 4.29302 8.35537H6.12705ZM9.97192 7.74377C9.88992 6.51516 9.46278 5.3375 8.74425 4.3448C10.396 4.65258 11.669 6.03803 11.8059 7.74377H9.97192ZM8.04945 3.66931C5.63031 3.66931 3.66919 5.63043 3.66919 8.04957C3.66919 10.4687 5.63031 12.4298 8.04945 12.4298C10.4686 12.4298 12.4298 10.4687 12.4298 8.04957C12.4298 5.63043 10.4686 3.66931 8.04945 3.66931ZM9.35878 7.74377H6.74012C6.82912 6.53562 7.28632 5.38367 8.04945 4.4435C8.81258 5.38368 9.26978 6.53562 9.35878 7.74377ZM8.04945 11.6556C7.28632 10.7155 6.82912 9.5635 6.74012 8.35537H9.35878C9.26978 9.5635 8.81258 10.7155 8.04945 11.6556Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_275_87"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 3,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_275_87"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeb);
export default __webpack_public_path__ + "static/media/web.bd5e54ae8ba14b3323b2a5781ed9f17b.svg";
export { ForwardRef as ReactComponent };